import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, SelectColumn } from './agt.analytics.store';

/**
 * Interface for Focus Themes data model
 * Based on agentur_focusthemen view schema:
 * - vtnr_id: Agency/Agent ID (integer)
 * - year: Year (integer)
 * - key: Theme key identifier (text)
 * - bnr_ids: Array of user IDs associated with this theme (integer[])
 */
export interface IAgtFocusthemenModel {
	vtnrId: number;
	year: number;
	key: string;
	bnrIds: number[];
}

/**
 * Model class for Focus Themes
 * Maps database columns from agentur_focusthemen view to TypeScript properties
 */
export class AgtFocusthemenModel implements IAgtFocusthemenModel {
	vtnrId: number;
	year: number;
	key: string;
	bnrIds: number[];

	constructor(data: any) {
		this.vtnrId = data.vtnr_id || 0;
		this.year = data.year || 0;
		this.key = data.key || '';
		this.bnrIds = data.bnr_ids || [];
	}
}

/**
 * Store for managing Focus Themes analytics
 * Extends AgtAnalyticsStore to query agentur_focusthemen view
 */
export class AgtFocusthemenStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_focusthemen',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE },
				{ column: 'year', aggregateFunction: AggregateFunction.NONE },
				{ column: 'key', aggregateFunction: AggregateFunction.NONE },
				{ column: 'a.bnr_ids', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?focusthemen';
	}
	/**
	 * Get all focus themes by year (optionally filtered)
	 */
	@action
	async getByYear(year?: number): Promise<AgtFocusthemenModel[]> {
		const whereClause = year ? `year = ${year}` : undefined;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map((data) => new AgtFocusthemenModel(data));
	}


}
